/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Script from 'next/script';
import environmentConfig from '@/config/environment';

export const JScrambler = () => {
  const jscramblerUrl = environmentConfig.JSCRAMBLER_URL;

  if (!jscramblerUrl) {
    return null;
  }

  return <Script src={jscramblerUrl} type="text/javascript" strategy="beforeInteractive" />;
};
